import { type GuardArgs } from '@sg/machines';

import { type ScanToPayContext } from './scan-to-pay.machine.context';
import { type ScanToPayEvents } from './scan-to-pay.machine.events';

// ─── Guards ──────────────────────────────────────────────────────────────────

const shouldFetchPaymentToken: Guard = ({ context }) => {
  return Boolean(context.paymentMethodId);
};

export const ScanToPayGuards = {
  shouldFetchPaymentToken,
};

// ─── Types ───────────────────────────────────────────────────────────────────

type Guard = (args: GuardArgs<ScanToPayContext, ScanToPayEvents>) => boolean;
